import React from "react";
import "./InstallationGuides.css";
function InstallationGuide(props) {
  return (
    <div>
      <marquee>
        <h2>Work In Progress</h2>
      </marquee>
      <div>
        <div class="card card-1">
          <div class="top">
            <img
              src="https://s-media-cache-ak0.pinimg.com/originals/45/2c/e7/452ce7c3ce3034806cf0fc781173507e.gif"
              alt="material ui"
            />
          </div>
          <div class="bottom">
            <p>MySql</p>
          </div>
        </div>
        <div class="card card-1">
          <div class="top">
            <img
              src="https://s-media-cache-ak0.pinimg.com/originals/97/56/c2/9756c2a05e2dd85309fe4b3bc5d62357.gif"
              alt="material ui"
            />
          </div>
          <div class="bottom">
            <a
              style={{
                textDecoration: "none",
                color: "black",
                textAlign: "center",
                fontSize: "0.5cm",
              }}
              target="_blank"
              href="https://stitch-lip-d84.notion.site/Project-Best-Practices-06a7971fefd748968847015fd16a3837"
            >
              <h5>Flutter</h5>
            </a>
          </div>
        </div>
        <div class="card card-1">
          <div class="top">
            <img
              src="https://img.freepik.com/free-vector/computer-troubleshooting-abstract-concept-illustration_335657-2211.jpg?size=338&ext=jpg"
              alt="material ui"
            />
          </div>
          <div class="bottom">
            <a
              style={{
                textDecoration: "none",
                color: "black",
                textAlign: "center",
                fontSize: "0.5cm",
              }}
              target="_blank"
              href="https://peppered-tuck-c46.notion.site/Web-Development-389cee680ae14f7cb134007fbea1fcf9"
            >
              <h5> React Js</h5>
            </a>
          </div>
        </div>
        <div class="card card-1">
          <div class="top">
            <img
              src="https://img.freepik.com/free-vector/tiny-people-testing-quality-assurance-software-isolated-flat-vector-illustration-cartoon-character-fixing-bugs-hardware-device-application-test-it-service-concept_74855-10172.jpg?size=626&ext=jpg"
              alt="material ui"
            />
          </div>
          <div class="bottom">
            <p>Business Management</p>
          </div>
        </div>
        <div class="card card-1">
          <div class="top">
            <img
              src="https://img.freepik.com/free-vector/software-installation-contract-adjustment-agreement-terms-regulation-program-fix-coworkers-holding-gears-cartoon-character-application-bugs_335657-2095.jpg?size=338&ext=jpg"
              alt="material ui"
            />
          </div>
          <div class="bottom">
            <p>Node JS </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InstallationGuide;
